import { useState, useEffect } from "react"

const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState({ x: null, y: null })

  const updateMousePosition = (ev) => {
    setMousePosition({ x: ev.pageX, y: ev.pageY })
  }

  useEffect(() => {
    window.addEventListener("mousemove", updateMousePosition)

    return () => window.removeEventListener("mousemove", updateMousePosition)
  }, [])

  return mousePosition
}

export default useMousePosition
